export class MaquinasFactory {
  constructor(instance) {
    this.instance = instance;
  }

  getMaquinas(filter) {
    return this.instance.get('/v1/cad-maquinas', {
      params: filter || null,
    });
  }

  getDashboard(filter) {
    return this.instance.get('/v1/cad-maquinas/dashboard', {
      params: filter || null,
    });
  }

  getAllHistoricoUtilizacao(filter) {
    return this.instance.get(`/v1/cad-maquinas/historicos`, {
      params: filter || null,
    });
  }

  getHistoricoUtilizacao(id, filter) {
    return this.instance.get(`/v1/cad-maquinas/${id}/historico`, {
      params: filter || null,
    });
  }

  getConsumo(id, filter) {
    return this.instance.get(`/v1/cad-maquinas/${id}/consumo`, {
      params: filter || null,
    });
  }

  getMaquina(id, filter) {
    return this.instance.get(`/v1/cad-maquinas/${id}`, {
      params: filter || null,
    });
  }

  addMaquina(data) {
    return this.instance.post('/v1/cad-maquinas', data);
  }

  reajusteMaquina(id, data) {
    return this.instance.post(
      `/v1/cad-maquinas/${id}/reajuste-valor-hora`,
      data,
    );
  }

  resumoCustoMaquina(id, filter) {
    return this.instance.get(`/v1/cad-maquinas/${id}/resumo-custo`, {
      params: filter || null,
    });
  }

  editMaquina(id, data) {
    return this.instance.put(`/v1/cad-maquinas/${id}`, data);
  }

  deleteMaquina(id) {
    return this.instance.delete(`/v1/cad-maquinas/${id}`);
  }

  getUltimoHorimetro(id, params) {
    return this.instance.get(`/v1/cad-maquinas/${id}/ultimo-horimetro`, {
      params: params || null,
    });
  }

  listTrocasHorimetro(id) {
    return this.instance.get(`/v1/cad-maquinas/${id}/troca-horimetro`);
  }

  trocarHorimetro(id, data) {
    return this.instance.post(`/v1/cad-maquinas/${id}/troca-horimetro`, data);
  }

  deleteFileMachine(id) {
    return this.instance.delete(`/v1/cad-maquinas/${id}/file`);
  }

  downloadHistMaquinaXlsx(id, filters) {
    return this.instance.patch(`/v1/cad-maquinas/${id}/historico/`, filters, {
      responseType: 'blob',
    });
  }
}

export default MaquinasFactory;
